var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileSeparationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 4,
    viewBox: "0 0 329 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.206526 2L2 3.79347L3.79347 2L2 0.206526L0.206526 2ZM328.793 2L327 0.206526L325.207 2L327 3.79347L328.793 2ZM2 2.31064H327V1.68936H2V2.31064Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSeparationLine);
export default __webpack_public_path__ + "static/media/mobile-separation-line.2dfdba98904b7fb89bbb9811a5076222.svg";
export { ForwardRef as ReactComponent };